// extracted by mini-css-extract-plugin
export var beatLoaderCenter = "TourBooking-module--beatLoaderCenter--2R2BA";
export var container = "TourBooking-module--container--x2ijq";